import React, { useEffect, useState, useContext, useRef, useMemo } from 'react'
import './searchItems.css'
import Slider from 'react-slick'
import { addSlashes, getParameterByName } from '../../../utils/commonFunctions'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import AlertContext from '../../../Product/context/alert/alertContext'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import SearchProductList from '../../../Component/ProductCard/lotListProduct'
import Layout from '../Layout'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FilterPanel from '../../../Product/components/organisms/FilterPanel'
import Loaders from '../../../Product/components/molecules/Loaders'
import { Button, Chip, Drawer, Link, Paper } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import BuyerContext from '../../../Product/context/buyer/buyerContext'
import { useLocation } from 'react-router-dom'
import { Pagination } from '@material-ui/lab'
import { load } from 'dotenv'
import { messageHandler } from '../../../Product/common/socketHandler'
import { socket, socketAuction } from '../../../Product/common/socket'
import CustomSelect from '../../../Product/components/atoms/Inputs/CustomSelect'
import UserActivity from '../../../utils/CommonFunctionality/UserActivity'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Rating } from '@material-ui/lab'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../Product/components/atoms/SecondaryButton'
import { ReactGoogleReviews } from 'react-google-reviews'
import Reviews from '../Home/review'
import LotProduct from '../../../Component/ProductCard/lotProduct'
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
    fullList: {
        width: 'auto',
    },
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        listStyle: 'none',
        boxShadow: 'none',
        padding: theme.spacing(0),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
        marginBottom: '15px',
    },
}))

const AuctionSearchComponent = (props) => {
    // const [cookies, setCookie] = useCookies(['user_session'])
    const location = useLocation()
    const buyerContext = useContext(BuyerContext)
    const productContext = useContext(ProductContext)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const history = useHistory()
    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })
    const { buyer_allproducts, getAllBuyerProducts, product_view, getViewProduct } = buyerContext

    const {
        search_allproducts,
        getAllSearchProducts,
        productLocalState,
        auc_cat_value,
        getallcatanditems,
        get_all_cat,
        getAllSearchItems,
        getAllSearchAuctions,
        search_allauctions,
    } = productContext
    const { setAlert } = alertContext
    const { user, isAuthenticated } = authContext
    const classes = useStyles()
    const [searchbar] = useState(new URLSearchParams(window.location.search.substring(1)).get('q'))
    const [isLoading, setLoading] = useState(true)
    const [viewProduct, setViewProduct] = useState([])
    const [suggestedProducts, setSuggestedProducts] = useState([])
    const [recentlyViewedProducts, setRecentlyViewedProducts] = useState([])
    const [locationfillter, setLocation] = useState([])
    const [auctionList, setAuctionList] = useState([])
    const [page, setPage] = useState(1)
    const [totalViewProduct, setTotalViewProduct] = useState(0)
    const [listview, setlistview] = useState(false)
    const [auctionView, setAuctionView] = useState('grid')
    const [favLoad, setFavLoad] = useState(false)
    const [audio] = useState(
        global.storeConfigration?.bidding_sound?.value == 1 ? new Audio('/audio/ding.mp3') : '',
    )
    const [catClass, setCatClass] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('cat'),
    )
    const [states, setStates] = useState([])
    const [searchCategories, setSearchCategories] = useState([])
    const [searchCategories2, setSearchCategories2] = useState([])
    const [size, setSize] = useState([])
    const params = new URLSearchParams(location.search)
    const [catg] = useState(new URLSearchParams(window.location.search.substring(1)).get('cat'))
    const [rat] = useState(new URLSearchParams(window.location.search.substring(1)).get('rat'))
    const [est] = useState(new URLSearchParams(window.location.search.substring(1)).get('est'))
    const [view] = useState(new URLSearchParams(window.location.search.substring(1)).get('view'))
    const [sort, setSortValue] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('sort'),
    )
    const [slimit] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('slimit'),
    )
    const [lotof] = useState(new URLSearchParams(window.location.search.substring(1)).get('lotof'))
    const [auctionTitle, setAuctionTitle] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('title'),
    )
    const [suggestedItemSearch, SetSuggestedItemSearch] = useState({
        orderby: sort != '' ? sort : '',
        category: catg == 1 || catg == 0 ? [] : [catg],
        subcategory: [],
        closed_auction_list: 0,
        perlimit: slimit !== '' ? slimit : 50,
        page: 1,
        joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
            user?.id ? ',IFNULL(w.id,0) as watchlisted' : ''
        }`,
        nobids: 1,
        latestbid: 1,
        latestbid_user: 1,
        userid: user?.id,
        getbidding: 1,
        need_bid_increment: 1,

        order_by: ' order by p.most_viewed DESC',
        customwhere: 'p.market_status="open" ',
        joins: user?.id
            ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
            : ` inner join auctionlot as a on a.id=p.lotof `,

        location: [],
        from: 'auction_only',
        from_id: 1,
        auction_io: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
        size: [],
        get_city_state: 1,
        dont_show: global?.storeConfigration?.donot_show_categories?.value
            ? global.storeConfigration?.donot_show_categories?.value?.split(',')
            : [],
    })

    const [recentlyViewedSearch, SetRecentlyViewedSearch] = useState({
        closed_auction_list: 0,
        perlimit: slimit !== '' ? slimit : 50,
        from: 'auction_only',
        from_id: 1,
        auction_io: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
        joinsdata:
            'a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id',
        size: [],
        get_city_state: 1,
        joins: ' inner join auctionlot as a on a.id=p.lotof ',
    })

    const active_sorts = {
        sorts: {
            sortcategoryTypes: ['2', '4', '5', '7', '8'],
            sortconditionTypes: ['2', '3', '5', '6'],
            sortsubCategoryTypes: ['1', '2', '3'],
            sortlocations: ['1', '2', '3', '18', '20'],
            sortall_notifications: [],
            sortbusiness_category: [],
            sortvat_registration: [],
        },
    }
    const getOrderBy = (orderby) => {
        let order = ' order by '

        if (orderby == '') {
            order += 'p.date_closed asc'
        }
        if (orderby == 1) {
            order += 'p.most_viewed DESC'
        }
        if (orderby == 7) {
            order += 'p.date_closed asc'
        }
        if (orderby == 3) {
            order += 'IF (p.auction = 1, p.wprice,p.bprice) asc'
        }
        if (orderby == 11) {
            order += 'IF (p.auction = 1, p.wprice,p.bprice) desc'
        }
        if (orderby == 6) {
            order += 'p.date_closed asc'
        }
        if (orderby == 2) {
            order += 'p.id desc'
        }
        if (orderby == 14) {
            if (global?.storeConfigration?.lot_sequence_order?.value == 1)
                order += 'CAST(p.lot_number AS UNSIGNED) ASC'
            else order += 'CAST(p.sku AS UNSIGNED) ASC'
        }
        if (orderby == 15) {
            if (global?.storeConfigration?.lot_sequence_order?.value == 1)
                order += 'CAST(p.lot_number AS UNSIGNED) DESC'
            else order += 'CAST(p.sku AS UNSIGNED) DESC'
        }
        if (
            global?.storeConfigration?.lot_sequence_order?.value == 1 &&
            orderby != 14 &&
            orderby != 15
        ) {
            order += ',CAST(p.lot_number AS UNSIGNED) ASC '
        }

        return order
    }
    const getSearchBar = (searchbar) => {
        let where = ''
        if (searchbar) {
            const searchValue = searchbar.trim()
            if (
                global.storeConfigration?.show_warehouse_location?.value == 1 &&
                global.storeConfigration?.lot_sequence_order?.value == 1
            ) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.location like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else if (global.storeConfigration?.lot_sequence_order?.value == 1) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else if (global.storeConfigration?.show_warehouse_location?.value == 1) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.location like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            }
        }
        return where
    }
    const getWhere = (type, keys, orderby) => {
        let where =
            lotof !== null
                ? `p.market_status="open" and p.lotof=${lotof}`
                : 'p.market_status="open"'

        where +=
            orderby == 7 ? ' and auction=1' : orderby == '01' ? ' and buynow=1 and auction=0' : ''
        if (type === 'search') {
            where += getSearchBar(keys)
        }
        if (type === 'location') {
            where += keys
        }
        return where
    }
    const formik = useFormik({
        initialValues: {
            orderby: sort != '' ? sort : '',
            category: catg == 1 || catg == 0 ? [] : [catg],
            subcategory: [],
            closed_auction_list: 0,
            perlimit: slimit !== '' ? slimit : 50,
            page: 1,
            joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                user?.id ? ',IFNULL(w.id,0) as watchlisted' : ''
            }`,
            nobids: 1,
            latestbid: 1,
            latestbid_user: 1,
            userid: user?.id,
            getbidding: 1,
            need_bid_increment: 1,
            delivery: [],
            order_by: getOrderBy(sort != '' ? sort : ''),
            customwhere:
                params.get('q') !== ''
                    ? getWhere('search', params.get('q'))
                    : getWhere('search', ''),
            joins: user?.id
                ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                : ` inner join auctionlot as a on a.id=p.lotof `,

            location: [],

            toprice: est !== '' ? est : 0,
            quality_rating: rat == null || rat == 1 || rat == '' ? [] : rat,
            from: 'auction_only',
            from_id: 1,
            auction_io: 1,

            auction_city:
                productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
            size: [],
            get_city_state: 1,
            dont_show: global?.storeConfigration?.donot_show_categories?.value
                ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                : [],
            special_events: [],
        },
    })

    useEffect(() => {
        setLoading(true)
        formik.setFieldValue(
            'auction_city',
            productLocalState.globalLocation == 'All' ? [] : [productLocalState.globalLocation],
        )
        let globalLoc =
            productLocalState.globalLocation == 'All'
                ? ''
                : ` and a.city="${productLocalState.globalLocation}"`
        getWhere('location', globalLoc)
        // formik.setFieldValue('customwhere', formik.values.customwhere + globalLoc)
        // getallcatanditems({
        //     site_id: global?.storeDetails?.site_id,
        //     lotof: 0,
        //     city: productLocalState.globalLocation == 'All' ? '' : productLocalState.globalLocation,
        //     from: 'get_all_items_count',
        // })
    }, [productLocalState.globalLocation])

    //We already calling this in Header Component, so commenting out
    // useEffect(() => {
    //     setLoading(true)
    //     getallcatanditems({
    //         site_id: global?.storeDetails?.site_id,
    //         lotof: 0,
    //         city: productLocalState.globalLocation == 'All' ? '' : productLocalState.globalLocation,
    //         from: 'get_all_items_count',
    //         status: formik.values.closed_auction_list == 0 ? 'open' : 'sold',
    //     })
    // }, [formik.values.closed_auction_list])

    useEffect(() => {
        if (get_all_cat.from == 'get_all_items_count') {
            if (get_all_cat.data.length > 0) {
                setSearchCategories2(get_all_cat.data.sort((a, b) => a.name.localeCompare(b.name)))
            }
            // if (get_all_cat?.size?.length > 0) {
            //     setSize(get_all_cat?.size?.sort((a, b) => a.size.localeCompare(b.size)))
            // }
        }
    }, [get_all_cat])

    useEffect(() => {
        getAllSearchItems(
            {
                ...suggestedItemSearch,
            },
            'suggestedItems',
        )
    }, [suggestedItemSearch])
    useEffect(() => {
        if (global.storeConfigration?.enable_recently_viewed?.value == 1) {
            let items = JSON.parse(localStorage.getItem('recentlyViewed')) || []
            let whereCondition = `p.market_status="open" `
            if (items.length >= 5) {
                whereCondition += ` and p.id in (${items.join(',')})`
            }

            getAllSearchItems(
                {
                    ...recentlyViewedSearch,

                    customwhere: whereCondition,
                },
                'recentlyViewedItems',
            )
        }
    }, [recentlyViewedSearch])
    // const sortChange = useMemo(() => {
    //     return new URLSearchParams(location.search).get('sort')
    // }, [location.search])
    // useEffect(() => {
    //     if (!sortChange) return
    //     formik.setFieldValue('order_by', getOrderBy(sortChange !== '' ? sortChange : ''))
    // }, [sortChange])
    useEffect(() => {
        getAllSearchAuctions(
            {
                auc_type: 3,
                auction_only: 1,
                orderby: '2',
                page: 1,
                searchbar: '',
                sh_limit: '10',
                type: '',
            },
            'searchPage',
        )
        localStorage.setItem('routeTo', '')
    }, [])
    useEffect(() => {
        if (search_allauctions.from === 'searchPage') {
            setAuctionList(search_allauctions.results.length ? search_allauctions.results : [])
        }
    }, [search_allauctions])
    useEffect(() => {
        const sortChange = new URLSearchParams(location.search).get('sort')
        formik.setFieldValue('order_by', getOrderBy(sortChange !== '' ? sortChange : ''))
    }, [location.search])

    const estimated_arr = [
        { id: 0, description: 'Any', value: [0] },
        { id: 1, description: 'Under $20', value: [0, 20] },
        { id: 2, description: '$20-$50', value: [20, 50] },
        { id: 3, description: '$50-$100', value: [50, 100] },
        { id: 4, description: '$100-$500', value: [100, 500] },
        { id: 5, description: 'Above $500', value: [500] },
    ]

    const ratings_arr = [
        {
            id: 0,
            description: <Rating name="read-only" value={5} precision={0.5} readOnly />,
            value: 'New',
        },
        {
            id: 1,
            description: <Rating name="read-only" value={4} precision={0.5} readOnly />,
            value: 'Powers On',
        },
        {
            id: 2,
            description: <Rating name="read-only" value={3} precision={0.5} readOnly />,
            value: 'Original Box',
        },
        {
            id: 3,
            description: <Rating name="read-only" value={2} precision={0.5} readOnly />,
            value: 'As Is Parts Only',
        },
        {
            id: 4,
            description: <Rating name="read-only" value={1} precision={0.5} readOnly />,
            value: 'NON RETURNABLE ITEM',
        },
    ]

    const handleCat = (id) => {
        let currentUrl = new URL(window.location.href)

        if (currentUrl.searchParams.has('cat')) {
            currentUrl.searchParams.set('cat', id)
            window.history.replaceState({}, '', currentUrl)
        }

        setCatClass(id)
        formik.setFieldValue('category', [id])
    }

    if (global?.storeConfigration?.need_buynow_search?.value == 1) {
        var filterValues = [
            {
                title: 'View',
                type: 'radio',
                noLabel: true,
                name: 'closed_auction_list',
                int: 1,
                class: 'col-12',
                item: [
                    { id: 0, description: 'Live Items' },
                    { id: 1, description: 'Closed Items' },
                ],
                formik: formik,
            },
            {
                title: 'Type',
                type: 'radio',
                noLabel: true,
                name: 'from_id',
                int: 1,
                class: 'col-12',
                item: [
                    { id: 0, description: 'All' },
                    { id: 1, description: 'Auction' },
                    { id: 2, description: 'Buy Now' },
                ],
                formik: formik,
            },
            {
                title: 'Category',
                type: 'check',
                name: 'category',
                int: 1,
                noLabel: true,
                options: global.searchCategories.filter((main) => {
                    return true
                }),
                formik: formik,
            },
            {
                title: 'Sub category',
                type: 'check',
                name: 'subcategory',
                options: global.searchSubCategories.filter((subcat) => {
                    // if (
                    //     formik &&
                    //     formik.values &&
                    //     formik.values.category &&
                    //     formik.values.category.length
                    //         ? formik.values.category.includes(subcat.level_id.toString())
                    //         : false
                    // ) {
                    return true
                    //}
                }),
                formik: formik,
            },
        ]
    } else {
        var filterValues = [
            {
                title: 'Auction Close Date',
                type: 'check',
                noLabel: true,
                name: 'special_events',
                int: 1,
                // class: 'col-12',
                options: search_allauctions?.results?.length
                    ? search_allauctions?.results
                          .sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))
                          .map((val) => {
                              return {
                                  description: moment(val.date_closed).format('MMMM Do (dddd)'),
                                  id: val.id,
                              }
                          })
                    : [],
                formik: formik,
            },
            // {
            //     title: 'View',
            //     type: 'radio',
            //     noLabel: true,
            //     name: 'closed_auction_list',
            //     int: 1,
            //     class: 'col-12',
            //     item: [
            //         { id: 0, description: 'Live Items' },
            //         // { id: 1, description: 'Closed Items' },
            //     ],
            //     formik: formik,
            // },
            {
                title: 'Condition',
                type: 'check',
                noLabel: true,
                name: 'quality_rating',
                int: 1,
                class: 'col-12',
                options: global.condition_data.map((item) => {
                    return {
                        ...item,
                        description: item.condition,
                    }
                }),
                formik: formik,
            },
            {
                title: 'Delivery Type',
                type: 'check',
                name: 'delivery',
                noLabel: true,
                class: 'col-12 d-block',
                options: [
                    {
                        value: '1',
                        id: '1',
                        show: 'Local Pickup',
                        description: 'Local Pickup',
                    },
                    {
                        value: '2',
                        id: '2',
                        show: 'Shipping',
                        description: 'Shipping',
                    },
                ],
                formik: formik,
            },
            {
                title: 'Category',
                type: 'check',
                name: 'category',
                noLabel: true,
                class: 'col-12',
                int: 1,
                options:
                    searchCategories2.length > 0 &&
                    global.storeConfigration?.cat_with_count?.value == 1
                        ? searchCategories2
                              .filter((data) => data?.name?.toLowerCase()?.trim() !== 'adult')
                              .map((data) => ({
                                  value: data.category_id,
                                  id: data.category_id,
                                  show: `${data.name} (${data.product_cnt})`,
                                  description: `${data.name} (${data.product_cnt})`,
                              }))
                        : searchCategories2
                              .filter((data) => data?.name?.toLowerCase()?.trim() !== 'adult')
                              .map((data) => ({
                                  value: data.category_id,
                                  id: data.category_id,
                                  show: `${data.name}`,
                                  description: `${data.name}`,
                              })),

                formik: formik,
            },
            {
                title: 'Size',
                type: 'check',
                name: 'size',
                noLabel: true,
                // int: 1,
                class: `${size?.length ? 'col-12 d-block' : 'd-none'}`,
                options:
                    searchCategories2.length > 0 &&
                    size?.map((data) => {
                        // if (formik.values.category.includes(data.category_id))
                        return {
                            value: data.size,
                            id: data.size,
                            show: `${data.size} (${data.product_cnt})`,
                            description: `${data.size} (${data.product_cnt})`,
                        }
                    }),

                // parentcategories.map((data) => {
                //     return {
                //         value: `${data.cat_id}`,
                //         show: data.cat_name,
                //         className: data.cat_id == catClass ? 'active' : '',
                //         description: `${data.cat_name} (${data.catcount})`,
                //         onChange: (e) => {
                //             return handleCat(e)
                //         },
                //     }
                // }),
                formik: formik,
            },
            // {
            //     title: 'Sub category',
            //     type: 'check',
            //     name: 'subcategory',
            // options: global.searchSubCategories.filter((subcat) => {
            // if (
            //     formik &&
            //     formik.values &&
            //     formik.values.category &&
            //     formik.values.category.length
            //         ? formik.values.category.includes(subcat.level_id.toString())
            //         : false
            // ) {
            //         return true
            //         //}
            //     }),
            //     formik: formik,
            // },

            {
                title: 'Estimated Retail',
                type: 'radio',
                noLabel: true,
                name: 'toprice',
                int: 1,
                class: 'col-12',
                item: estimated_arr,
                formik: formik,
            },
            {
                title: 'Adult',
                type: 'check',
                name: 'category',
                noLabel: true,
                class: searchCategories2?.find((val) => val?.name?.toLowerCase()?.trim() == 'adult')
                    ? 'col-12'
                    : 'd-none',
                int: 1,
                options: searchCategories2?.find(
                    (val) => val?.name?.toLowerCase()?.trim() == 'adult',
                )
                    ? searchCategories2
                          .filter((data) => data?.name?.toLowerCase()?.trim() == 'adult')
                          .map((data) => ({
                              value: data.category_id,
                              id: data.category_id,
                              show: `${data.name} (${data.product_cnt})`,
                              description: `${data.name} (${data.product_cnt})`,
                          }))
                    : [],
                formik: formik,
            },
        ]
    }

    useEffect(() => {
        // setLoading(true)
        if (search_allproducts.from === 'searchPage') {
            setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
            setTotalViewProduct(search_allproducts.total_pagecnt)
            // if (search_allproducts?.maincategory.length > 0) {
            //     setParentCategories(search_allproducts.maincategory)
            // } else {
            //     setParentCategories([])
            // }
            setLoading(false)
        }
        if (search_allproducts.from === 'recentlyViewedItems') {
            setRecentlyViewedProducts(
                search_allproducts.results.length ? search_allproducts.results : [],
            )
        }
        if (search_allproducts.from === 'suggestedItems') {
            setSuggestedProducts(
                search_allproducts.results.length ? search_allproducts.results : [],
            )
        }
        if (
            search_allproducts?.categoriesCounts?.length > 0 &&
            searchCategories?.length == 0 &&
            global.storeConfigration?.cat_with_count?.value
        ) {
            var new_cat = global.searchCategories
            new_cat.map((value) => {
                value.catcount =
                    search_allproducts.categoriesCounts.filter(
                        (val) => parseInt(val.category_id) == parseInt(value.id),
                    ).length > 0
                        ? search_allproducts.categoriesCounts.filter(
                              (val) => parseInt(val.category_id) == parseInt(value.id),
                          )[0].CountCat
                        : 0
                if (!value.description.includes(value.catcount)) {
                    value.description = `${value.description + ' '}(${value.catcount})`
                }
            })

            setSearchCategories(new_cat)
        }
        setSize(
            get_all_cat?.size?.filter((val) => formik.values.category.includes(val.category_id)),
        )
        setStates(search_allproducts.city)
        // setTimeout(() => {
        //     setLoading(false)
        // }, 1000)
    }, [search_allproducts, formik.values])

    useEffect(() => {
        setViewProduct([])
        return () => {
            setViewProduct([])
        }
    }, [])

    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)

    // Sets product and user refrences on page load
    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
        )
    }

    useEffect(() => {
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        socket.on('cancelbidemitted', (data) => {
            handler(data, 'cancelbidemitted')
        })

        socket.on('watchlist', (data) => {
            handler(data, 'watchlist')
        })
        socket.on('product_view_count', (data) => {
            handler(data, 'product_view_count')
        })

        socketAuction.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socketAuction.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })

            socket.off('cancelbidemitted', (data) => {
                handler(data, 'cancelbidemitted')
            })

            socket.off('watchlist', (data) => {
                handler(data, 'watchlist')
            })
            socket.off('product_view_count', (data) => {
                handler(data, 'product_view_count')
            })

            socketAuction.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socketAuction.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
        }
    }, [])

    const onHandlePage = (event, value) => {
        setPage(value)
        setLoading(true)
        // getAllSearchProducts(
        //     {
        //         ...formik.values,
        //         fromprice: undefined,
        //         toprice: undefined,
        //         quality_rating: undefined,
        //         mprice_filter: estimated_arr.filter(
        //             (val) => parseInt(val.id) == parseInt(formik.values.toprice),
        //         )[0].value,
        //         rating_multiple_io: global.condition_data
        //             .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
        //             .map((item) => item.condition),
        //         page: value,
        //     },
        //     'searchPage',
        // )
        getAllSearchItems(
            {
                ...formik.values,
                quality_rating: undefined,
                mprice_filter: estimated_arr.filter(
                    (val) => parseInt(val.id) == parseInt(formik.values.toprice),
                )[0].value,
                rating_multiple_io: global.condition_data
                    .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
                    .map((item) => item.condition),
                page: value,
            },
            'searchPage',
        )
        setLoading(false)
        window.scrollTo(0, 0)
    }

    const getAllProduct = async (bool) => {
        // setLoading(true)
        // getAllSearchProducts(formik.values, 'searchPage').then((res) => {
        //     if (res.success === 'yes' && params.get('product'))
        //         getViewProduct({ product_id: Number(params.get('product')) })
        // })
        // setTimeout(() => {
        //     setLoading(false)
        // }, 1000)
    }

    const settings = {
        dots: true,
        fade: false,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: 'linear',
    }

    useEffect(() => {
        // setLoading(true)
        /*  if (formik.values.closed_auction_list) {
            formik.values.orderby = '7'
        } */

        if (global?.storeConfigration?.need_buynow_search?.value == 1) {
            if (parseInt(formik.values.from_id) == 0) {
                formik.values.from = ''
            } else if (parseInt(formik.values.from_id) == 1) {
                formik.values.from = 'auction_only'
            } else {
                formik.values.from = 'buynow'
            }

            params.set('at', formik.values.from_id)

            history.replace({
                pathname: location.pathname,
                search: params.toString(),
            })
        }
        let currentUrl = new URL(window.location.href)

        if (currentUrl.searchParams.has('rat')) {
            currentUrl.searchParams.set('rat', formik.values.quality_rating)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('est')) {
            currentUrl.searchParams.set('est', formik.values.toprice)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('sort')) {
            currentUrl.searchParams.set('sort', formik.values.orderby)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('cat')) {
            currentUrl.searchParams.set('cat', formik.values.category)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('slimit')) {
            currentUrl.searchParams.set('slimit', formik.values.perlimit)
            window.history.replaceState({}, '', currentUrl)
        }
        setPage(1)

        getAllSearchItems(
            {
                ...formik.values,
                quality_rating: undefined,
                mprice_filter: estimated_arr.filter(
                    (val) => parseInt(val.id) == parseInt(formik.values.toprice),
                )[0].value,
                rating_multiple_io: global.condition_data
                    .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
                    .map((item) => item.condition),
                dont_show: formik.values.category.some((val) =>
                    formik.values.dont_show?.includes(val),
                )
                    ? []
                    : global?.storeConfigration?.donot_show_categories?.value
                    ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                    : [],
                page: 1,
                joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                    user?.id
                        ? `,IFNULL(w.id,0) as watchlisted ,(SELECT proposed_amount FROM bids WHERE project_id = p.id AND user_id = ${user?.id} and declined=0  ORDER BY id DESC LIMIT 0,1) AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                        : ''
                }`,
                joins: user?.id
                    ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                    : ` inner join auctionlot as a on a.id=p.lotof `,
            },
            'searchPage',
        )
        setLoading(true)
        window.scrollTo(0, 0)
    }, [formik.values])

    useEffect(() => {
        if (user?.id) {
            if (global?.storeConfigration?.need_buynow_search?.value == 1) {
                if (parseInt(formik.values.from_id) == 0) {
                    formik.values.from = ''
                } else if (parseInt(formik.values.from_id) == 1) {
                    formik.values.from = 'auction_only'
                } else {
                    formik.values.from = 'buynow'
                }

                params.set('at', formik.values.from_id)

                history.replace({
                    pathname: location.pathname,
                    search: params.toString(),
                })
            }
            let currentUrl = new URL(window.location.href)

            if (currentUrl.searchParams.has('rat')) {
                currentUrl.searchParams.set('rat', formik.values.quality_rating)
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('est')) {
                currentUrl.searchParams.set('est', formik.values.toprice)
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('sort')) {
                currentUrl.searchParams.set('sort', formik.values.orderby)
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('cat')) {
                currentUrl.searchParams.set('cat', formik.values.category)
                window.history.replaceState({}, '', currentUrl)
            }
            if (currentUrl.searchParams.has('slimit')) {
                currentUrl.searchParams.set('slimit', formik.values.perlimit)
                window.history.replaceState({}, '', currentUrl)
            }
            setPage(1)

            getAllSearchItems(
                {
                    ...formik.values,
                    quality_rating: undefined,
                    mprice_filter: estimated_arr.filter(
                        (val) => parseInt(val.id) == parseInt(formik.values.toprice),
                    )[0].value,
                    rating_multiple_io: global.condition_data
                        .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
                        .map((item) => item.condition),
                    dont_show: formik.values.category.some((val) =>
                        formik.values.dont_show?.includes(val),
                    )
                        ? []
                        : global?.storeConfigration?.donot_show_categories?.value
                        ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                        : [],
                    page: 1,
                    joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                        user?.id
                            ? `,IFNULL(w.id,0) as watchlisted ,(SELECT proposed_amount FROM bids WHERE project_id = p.id AND user_id = ${user?.id} and declined=0  ORDER BY id DESC LIMIT 0,1) AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                            : ''
                    }`,
                    joins: user?.id
                        ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                        : ` inner join auctionlot as a on a.id=p.lotof `,
                },
                'searchPage',
            )
            getAllSearchItems(
                {
                    ...suggestedItemSearch,
                    page: 1,
                    joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                        user?.id
                            ? `,IFNULL(w.id,0) as watchlisted ,(SELECT proposed_amount FROM bids WHERE project_id = p.id AND user_id = ${user?.id} and declined=0  ORDER BY id DESC LIMIT 0,1) AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                            : ''
                    }`,
                    joins: user?.id
                        ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                        : ` inner join auctionlot as a on a.id=p.lotof `,
                },
                'suggestedItems',
            )
            setLoading(true)
        }
    }, [user])

    useEffect(() => {
        if (
            formik.values.category ||
            formik.values.subcategory ||
            formik.values.closed_auction_list ||
            formik.values.perlimit
        ) {
            setPage(1)
        }
    }, [
        formik.values.category,
        formik.values.subcategory,
        formik.values.closed_auction_list,
        formik.values.perlimit,
    ])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search.substring(1))
        const catValue = params.get('cat')
        formik.setFieldValue(
            'category',
            catValue && catValue.trim() !== '' ? catValue.split(',') : [],
        )
        formik.setFieldValue(
            'customwhere',
            params.get('q') ? getWhere('search', params.get('q')) : getWhere('search', ''),
        )
        formik.setFieldValue(
            'from_id',
            params.get('q') && params.get('at')
                ? params.get('at')
                : params.get('q')
                ? 0
                : params.get('at')
                ? params.get('at')
                : 1,
        )
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search.substring(1))
        const qValue = params.get('q')
        const catValue = params.get('cat')
        const orderbyValue = params.get('sort')
        const title = params.get('title')
        formik.setFieldValue(
            'category',
            catValue && catValue.trim() !== '' ? catValue.split(',') : [],
        )
        const customwhere =
            qValue !== ''
                ? getWhere('search', qValue, orderbyValue)
                : getWhere('search', '', orderbyValue)
        formik.setFieldValue('orderby', orderbyValue)
        formik.setFieldValue('customwhere', customwhere)
        setAuctionTitle(title)
    }, [window.location.search])

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    const pageOptions = [
        {
            value: '50',
            show: 'Results 50 per page',
        },
        {
            value: '75',
            show: 'Results 75 per page',
        },
        {
            value: '100',
            show: 'Results 100 per page',
        },
    ]

    const sortShow = [
        {
            value: '',
            show: 'None',
        },
        {
            value: 3,
            show: 'Current price low to high',
        },
        {
            value: 11,
            show: 'Current price high to low',
        },
        {
            value: 6,
            show: 'Time remaining',
        },
        {
            value: 2,
            show: 'Recently listed',
        },
    ]

    const NextArrow = (props) => {
        const { className, style, onClick } = props
        return (
            <div
                className={className}
                style={{ ...style, display: 'block', right: -25, top: 70, zIndex: 999 }}
                onClick={onClick}
            >
                <span className="material-icons-outlined" size="14">
                    navigate_next
                </span>
            </div>
        )
    }

    const PrevArrow = (props) => {
        const { className, style, onClick } = props
        return (
            <div
                className={className}
                style={{ ...style, display: 'block', left: -50, top: 70, zIndex: 999 }}
                onClick={onClick}
            >
                <span className="material-icons-outlined" size="14">
                    navigate_left
                </span>
            </div>
        )
    }

    const settings4 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        nav: false,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const settings5 = {
        dots: false,
        fade: false,
        arrows: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        nav: false,
        centerMode: false,
        variableWidth: false,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    const [chipData, setChipData] = React.useState([
        { key: 0, label: 'Angular' },
        { key: 1, label: 'jQuery' },
        { key: 2, label: 'Polymer' },
        { key: 3, label: 'Vue.js' },
    ])

    const handleDelete = (chipToDelete) => () => {
        setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key))
    }

    return (
        <Layout props={props}>
            <UserActivity page="lot_search" />
            <div className="customContainer position-relative">
                {isVarifiedGfTheme && (
                    <div className="searchBanner">
                        {global?.storeConfigration?.liq_home_page_banner_changes?.value == 1 ? (
                            <div className="siteBanner multiple">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: static_page.content,
                                    }}
                                ></div>
                            </div>
                        ) : global.multipleBannersFields.length ? (
                            <div className="siteBanner multiple">
                                {
                                    <Slider {...settings}>
                                        {global.multipleBannersFields?.map((data, index) => (
                                            <div className="banner-item" key={index}>
                                                <img
                                                    src={
                                                        process.env.REACT_APP_AUCTION_IMAGE_URL +
                                                        '/' +
                                                        data?.image_name
                                                    }
                                                />
                                            </div>
                                        ))}
                                    </Slider>
                                }
                            </div>
                        ) : (
                            <div className="siteBanner">
                                <LazyLoadImage
                                    src={global?.storeDetails?.bannerValue}
                                    alt={`${global?.storeDetails?.name} banner`}
                                    effect="blur"
                                    height="100%"
                                    width="100%"
                                />
                                <div className="bannerContent">
                                    <h2>{global?.storeDetails?.description}</h2>
                                    <PrimaryButton
                                        label="Explore Now"
                                        disabled={isLoading}
                                        onClick={() =>
                                            handleLocationChange(
                                                productLocalState.globalLocations[0],
                                            )
                                        }
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <div className="searchContainer">
                    <div className="searchLt">
                        <FilterPanel formik={formik} filterValues={filterValues} />
                    </div>
                    <div className="searchRt">
                        <div className="searchMiscAct d-flex justify-content-end flex-wrap my-3">
                            {isVarifiedGfTheme && auctionTitle !== null && (
                                <h4 className="auctionTitle">
                                    {auctionTitle == 'Flash Deals' ||
                                    auctionTitle == 'Todays Top Deals' ||
                                    auctionTitle == 'Recently Listed' ||
                                    auctionTitle == 'Deals Ending Soon' ||
                                    auctionTitle == 'Buy Now'
                                        ? auctionTitle
                                        : 'Auctions'}
                                </h4>
                            )}
                            {!isVarifiedGfTheme && (
                                <>
                                    <div className="gridListToggle">
                                        <Button
                                            className={auctionView != 'list' ? 'active' : ''}
                                            onClick={() => setAuctionView('grid')}
                                        >
                                            <img src="/lots-images/loa-grid-icon.svg" alt="" />
                                        </Button>
                                        <Button
                                            className={auctionView === 'list' ? 'active' : ''}
                                            onClick={() => setAuctionView('list')}
                                        >
                                            <img src="/lots-images/loa-list-icon.svg" alt="" />
                                        </Button>
                                    </div>
                                    {search_allproducts &&
                                        !!totalViewProduct &&
                                        totalViewProduct > formik.values.perlimit &&
                                        !isLoading && (
                                            <Pagination
                                                count={Math.ceil(
                                                    totalViewProduct / formik.values.perlimit,
                                                )}
                                                totalProductCount={totalViewProduct}
                                                currentPage={formik.values.page}
                                                page={page}
                                                onChange={onHandlePage}
                                            />
                                        )}
                                    <CustomSelect
                                        label="Results per page"
                                        name="resultsPerPage"
                                        selectType="noBorder"
                                        value={formik.values.perlimit}
                                        size="small"
                                        onChange={(event, editor) => {
                                            formik.setFieldValue('perlimit', event.target.value)
                                        }}
                                    >
                                        {pageOptions.map((opt, optindex) => (
                                            <option value={opt.value}>{opt.show}</option>
                                        ))}
                                    </CustomSelect>
                                    <CustomSelect
                                        label="Sort by"
                                        value={formik.values.orderby}
                                        size="small"
                                        selectType="noBorder"
                                        name="order_by"
                                        // shrink={search.orderby !== '' ? true : false}
                                        onChange={(event, editor) => {
                                            formik.setFieldValue(
                                                'order_by',
                                                getOrderBy(event.target.value),
                                            )

                                            formik.setFieldValue('orderby', event.target.value)
                                        }}
                                    >
                                        {sortShow.map((opt, optindex) => (
                                            <option value={opt.value}>{opt.show}</option>
                                        ))}
                                    </CustomSelect>
                                </>
                            )}
                            <Button
                                className="toggleRespDrawer"
                                variant="outlined"
                                onClick={toggleDrawer('bottom', true)}
                            >
                                <span className="material-icons">tune</span>
                                Filters
                            </Button>
                        </div>
                        {/* <div>
                            <Paper component="ul" className={classes.root}>
                                {chipData.map((data) => {
                                    return (
                                        <li key={data.key}>
                                            <Chip
                                                label={data.label}
                                                onDelete={
                                                    data.label === 'React'
                                                        ? undefined
                                                        : handleDelete(data)
                                                }
                                                className={classes.chip}
                                            />
                                        </li>
                                    )
                                })}
                            </Paper>
                        </div> */}
                        {isLoading ? (
                            <div>
                                <Loaders name="product_grid_view" isLoading={isLoading} loop={6} />
                            </div>
                        ) : viewProduct.length > 0 ? (
                            <SearchProductList
                                listview={auctionView == 'list'}
                                searchResult={viewProduct}
                                setViewProduct={setViewProduct}
                                className="liquidationBuyCard"
                                getAllProducts={getAllProduct}
                                cardType={auctionView}
                                audio={audio}
                                enableZoomOnHover={true}
                                at={formik.values.from_id}
                                card_theme="lotsauction"
                                noBuyNow={true}
                            />
                        ) : (
                            <NoRecordsFound />
                        )}
                        {search_allproducts &&
                            !!totalViewProduct &&
                            totalViewProduct > formik.values.perlimit &&
                            !isLoading && (
                                <Pagination
                                    count={Math.ceil(totalViewProduct / formik.values.perlimit)}
                                    totalProductCount={totalViewProduct}
                                    currentPage={formik.values.page}
                                    page={page}
                                    onChange={onHandlePage}
                                />
                            )}
                    </div>
                </div>
            </div>
            {isVarifiedGfTheme && (
                <>
                    <div className="why-choose">
                        <div className="customContainer">
                            <div className="googleReviewPoint mt-4">
                                <div className="customContainer pb-4">
                                    {isVarifiedGfTheme ? (
                                        // <ReactGoogleReviews
                                        //     layout="carousel"
                                        //     featurableId={
                                        //         process.env.REACT_APP_FEATURABLE_PLUGIN_ID
                                        //     }
                                        // />
                                        <NoRecordsFound text={'Google Reviews Coming Soon!'} />
                                    ) : (
                                        <Reviews />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="searchSuugerItems">
                        <div className="customContainer">
                            <div className="searchSuugerItemsBox">
                                <div className="customContainer">
                                    <h4 className="title">Suggested Items </h4>
                                    {suggestedProducts.length > 0 ? (
                                        <Slider {...settings5}>
                                            {suggestedProducts.map((item, index) => (
                                                <div key={index} className="px-2">
                                                    <LotProduct
                                                        data={item}
                                                        lotImages={item.lotImages}
                                                        link={`/gallery/product-view/${item.id}`}
                                                        handleClick={() =>
                                                            handleRedirectInternal(
                                                                history,
                                                                `product/${id}?cat=`,
                                                            )
                                                        }
                                                        timerTheme={props.timerTheme}
                                                        type={props.type ? props.type : ''}
                                                        cardTheme={props.cardTheme}
                                                        card_theme="lotsauction"
                                                        noBuyNow={true}
                                                        noTimer={props.noTimer}
                                                        getAllProducts={getAllSearchProducts}
                                                        setViewProduct={setViewProduct}
                                                        viewProduct={viewProduct}
                                                        audio={props.audio}
                                                        productViewLink={`/product/${item.id}?cat=`}
                                                        bidStatus="true"
                                                        timerIcon={true}
                                                        searchCard={true}
                                                        hideQuickBid={
                                                            props.hideQuickBid
                                                                ? props.hideQuickBid
                                                                : false
                                                        }
                                                    />
                                                </div>
                                            ))}
                                        </Slider>
                                    ) : (
                                        <div className="card card-body text-center">
                                            No items Found!
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="why-choose searchlayout">
                        <div className="customContainer">
                            <div className="googleReviewPoint mt-4 recent">
                                <div className="customContainer">
                                    <h4 className="title">Recently Viewed</h4>
                                    {recentlyViewedProducts.length > 0 ? (
                                        <Slider {...settings4}>
                                            {recentlyViewedProducts.map((data, index) => (
                                                <div key={index} className="recenlyCard">
                                                    <a href={`product/${data.id}`}>
                                                        <img
                                                            src={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}${data.avatar_vc}`}
                                                            alt="view Images"
                                                            width={100}
                                                            height={100}
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </Slider>
                                    ) : (
                                        <div className="card card-body text-center">
                                            No items Found!
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <Drawer
                anchor="bottom"
                open={state['bottom']}
                className="responsiveFilterDrawer"
                onClose={toggleDrawer('bottom', false)}
                onOpen={toggleDrawer('bottom', true)}
            >
                <div
                    className={clsx(classes.list, 'bottom')}
                    role="presentation"
                    // onClick={toggleDrawer('bottom', false)}
                    onKeyDown={toggleDrawer('bottom', false)}
                >
                    <FilterPanel formik={formik} filterValues={filterValues} />
                </div>
            </Drawer>
        </Layout>
    )
}

export default AuctionSearchComponent
